import { createActionName } from "../../../utility"

export const reducerName = "topics"

export const TOPIC = createActionName(reducerName, "TOPIC")
export const TOPICS = createActionName(reducerName, "TOPICS")
